import { Slot } from '@radix-ui/react-slot';
import { Link as BaseLink, useLocation } from 'react-router-dom';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/styles';
import { forwardRef } from 'react';

export const linkVariants = cva(
  'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-stroke-primary-subtle ring-offset-2 disabled:pointer-events-none disabled:text-tertiary',
  {
    variants: {
      variant: {
        flat: '',
        underline:
          'transition-colors typography-btn-large text-primary underline-offset-4 underline',
        default:
          'transition-colors typography-btn-large inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg h-9 text-primary hover:text-secondary active:text-secondary [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface LinkProps
  extends React.ComponentPropsWithoutRef<typeof BaseLink>,
    VariantProps<typeof linkVariants> {
  asChild?: boolean;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ asChild, variant, children, className, ...rest }, ref) => {
    const location = useLocation();
    const Comp = asChild ? Slot : BaseLink;

    return (
      <Comp
        ref={ref}
        state={{ from: location }}
        className={cn(linkVariants({ variant }), className)}
        {...rest}
      >
        {children}
      </Comp>
    );
  },
);
